import {
  Badge,
  Card,
  Grid,
  Icon,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import downloadArrow from "../../assets/images/downloadArrow.png";
import map from "../../assets/images/map.webp";
import mapWithMarker from "../../assets/images/mapWithMarker.webp";
import orderManagerImg from "../../assets/images/orderManagerImg.webp";
import vesselInfo from "../../assets/images/vesselInfo.webp";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import MockDialogBox from "./MockDialogBox";
import MockEmailDetails from "./MockEmailDetails";
import { MockMileStoneTrackerModal } from "./mockModalData";
import MockTooltipComponent from "./MockTooltipComponent";
import MockTrackingDetailsForm from "./MockTrackingDetailsForm";
import { getProgress, updateUserJourneyState } from "./mockUtils";
import MockFreeTrial from "./MockFreeTrial";
import MockMilestoneSidebar from "./milestoneTracker/MockMilestoneSidebar";
import MockCommunicationHistory from "./milestoneTracker/MockCommunicationHistory";
import moment from "moment-timezone";

let dateArr = [];
let dateObj = new Date();
let date = dateObj.getDate();
let year = dateObj.getFullYear();
let month = dateObj.getMonth();


const mockOrderTimeLine = [
  {
    title: "Location Risk",
    when: `Mar 14, ${year} at 1:46PM GMT`,
    description: "Tensions escalate between China and Taiwan",
  },
  {
    title: "Logistic Risk",
    when: `Mar 14, ${year} at 1:46PM GMT`,
    description: "Severe congestion at Shanghai port",
  },
  {
    title: "Delivery Date Risk",
    when: `Mar 14, ${year} at 1:46PM GMT`,
    description: "Supplier has proposed a new delivery date. 13 day delay expected. Approve or reject now",
  },
];

const mockVesselInfo = [
  {
    title: "Vessel Name",
    value: "Fabric Gallery Ltd",
  },
  {
    title: "Vessel Type",
    value: "Carrier",
  },
  {
    title: "Home Port",
    value: "Yantian",
  },
  {
    title: "Status",
    value: "Active",
  },
  {
    title: "Service Provider",
    value: "Maersk",
  },
  {
    title: "Container Number",
    value: "MKRU9283775",
  },
  {
    title: "MMSI Number",
    value: "9619907",
  },
];

const MockTable = [
  {
    updated_delivery_date: `Sept 27, ${year}`,
    update_type: "Ex Mill",
    submitted_on: `October 1, ${year}`,
    comment_by: "Supplier",
    comment: "We’ve experienced some QA issues which delayed Ex Mill date. New date will be met",
  },
  {
    updated_delivery_date: `Oct 1, ${year}`,
    update_type: "Ex Country",
    submitted_on: `Aug 30, ${year}`,
    comment_by: "Jones",
    comment: "Forwarder has confirmed Ex Country date will be met. We have confirmed with supplier and logistics has been booked.",
  },
  {
    updated_delivery_date: `Sep 21, ${year}`,
    update_type: "Ex Mill",
    submitted_on: `Aug 21, ${year}`,
    comment_by: "Supplier",
    comment: "On track to meet Ex Mill date. Currently undergoing QA",
  },
  {
    updated_delivery_date: `Sep 25, ${year}`,
    update_type: "Ex Country",
    submitted_on: `Aug 14, ${year}`,
    comment_by: "Jones",
    comment: "Forwarder awaiting final confirmation. ",
  },
  {
    updated_delivery_date: `Sep 21, ${year}`,
    update_type: "Ex Mill",
    submitted_on: `Aug 1, ${year}`,
    comment_by: "Supplier",
    comment: "Order under finishing stage. On track for Ex Mill date",
  },
]

const MockMilestoneTracker = () => {
  const history = useHistory();
  const userContext = useContext(userJourneyContext);
  const classes = useStyles();
  const [firstTooltipOpen, setFirstTooltipOpen] = useState(false);
  const [secondTooltipOpen, setSecondTooltipOpen] = useState(false);
  const [thirdTooltipOpen, setThirdTooltipOpen] = useState(false);
  const [milestoneWidth, setMilestoneWidth] = useState("374px");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openEmail, setOpenEmail] = React.useState(false);
  const [openComposeEmail, setOpenComposeEmail] = React.useState(true);
  const [beforeEmail, setBeforeEmail] = React.useState(true);
  const [openSelectAction, setOpenSelectAction] = React.useState(false);
  const [openSelectActionForm, setOpenSelectActionForm] = React.useState(false);
  const [openTrackingDetails, setOpenTrackingDetails] = React.useState(false);
  const [showVesselInfoWithImg, setShowVesselInfoWithImg] =
    React.useState(false);
  const [showFinalOrderTimeline, setShowFinalOrderTimeline] =
    React.useState(false);
  const [openToolTipForCommunication, setOpenToolTipForCommunication] =
    React.useState(false);
  const [readMore, setReadMore] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
  });

  const [categoryTab, setCategoryTab] = useState([
    "Order Timeline",
    "Communication Hub",
    "Documents",
    "Order Risks (3)",
    "Logistic",
  ]);
  const [defaultCategoryTab, setDefaultCategoryTab] = useState(3);
  const [progress, setProgress] = useState(0);
  const milestonesRef = React.useRef(null);
  const bottomRef = React.useRef(null);

  function absVal(integer) {
    return integer < 0 ? -integer : integer;
  }

  const changeDate = (dObj, d, m, y, n) => {
    if (d - n < 1) {
      if (m < 0) {
        month = 0;
        year = y + 1
        date = absVal(absVal(d - n) - (new Date(y, 1, 0).getDate()));
      } else {
        month = m - 1
        date = absVal(absVal(d - n) - (new Date(y, m + 1, 0).getDate()));
      }
    } else {
      date = d - n;
    }
    dateObj = new Date(year, month, date);
    return moment(dateObj).format('ll');
  }

  const updateDateArr = () => {
    [0, 3, 9, 6, 15, 3].map((n, i) => {
      dateArr.push(changeDate(dateObj, date, month, year, n))
    })
  }

  useEffect(() => {
    if (dateArr.length <= 0) {
      updateDateArr();
    }
  }, [])

  const mockMilestones = [
    {
      color: "timeLineMilestoneBlueColor",
      status: "PO Placed",
      date: `${dateArr[5]}`,
    },
    {
      color: "timeLineMilestoneBlueColor",
      status: "Planned for Production",
      date: `${dateArr[4]}`,
    },
    {
      color: "timeLineMilestoneBlueColor",
      status: "Under Production -> Knitting ",
      date: `${dateArr[3]}`,
    },
    {
      color: "timeLineMilestoneBlueColor",
      status: "Under Production -> Dyeing",
      date: `${dateArr[2]}`,
    },
    {
      color: "timeLineMilestoneRedColor",
      status: "Under Production -> Finishing ",
      date: `${dateArr[1]}`,
    },
    {
      color: "timeLineMilestoneYellowColor",
      status: "Quality Assurance ",
      date: `${dateArr[0]}`,
    },
    {
      color: "timeLineMilestoneFadeColor",
      status: "Ready to be Shipped",
    },
    {
      color: "timeLineMilestoneFadeColor",
      status: "In Transit -> Source Port Dwell",
    },
    {
      color: "timeLineMilestoneFadeColor",
      status: "In Transit -> Vessel",
    },
    {
      color: "timeLineMilestoneFadeColor",
      status: "In Transit -> Destination Port Dwell",
    },
    {
      color: "timeLineMilestoneFadeColor",
      status: "In Transit -> Last Mile",
    },
    {
      color: "timeLineMilestoneFadeColor",
      status: "Arrived at Warehouse",
    },
  ];

  React.useEffect(() => {
    setProgress(getProgress(userContext.userJourneyInfo));
    if (userContext.userJourneyInfo.payload.steps === 8) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [userContext.userJourneyInfo.payload.steps]);

  React.useEffect(() => {
    if (defaultCategoryTab === "Order Timeline" || defaultCategoryTab === 0) {
      setThirdTooltipOpen(true);
      milestonesRef.current?.scrollIntoView({ behavior: "smooth" });
      if (openSelectAction) {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    } else if (
      defaultCategoryTab === "Communication Hub" ||
      defaultCategoryTab === 1
    ) {
      setOpenToolTipForCommunication(false);
    }
  }, [defaultCategoryTab]);

  const handleChange = (event, category) => {
    if (category === "Order Timeline" && userContext.userJourneyInfo.payload.steps === 9 || userContext.userJourneyInfo.payload.steps === 15) {
      setDefaultCategoryTab(category);
    }
    if (category === "Communication Hub" && userContext.userJourneyInfo.payload.steps === 11) {
      setDefaultCategoryTab(category);
    }
  };

  const makeApiCall = () => {
    (async () => {
      try {
        userContext.setUserJourneyInfo(
          updateUserJourneyState(userContext.userJourneyInfo)
        );
        userContext.setUserJourneyProgress(
          getProgress(userContext.userJourneyProgress)
        );
      } catch (e) {
        console.log(e);
      }
    })();
  };

  const clickOnToolTip = (stepTitle, toolTipNo, event) => {
    if (toolTipNo === 1) {
      setFirstTooltipOpen(false);
      setSecondTooltipOpen(true);
    } else if (toolTipNo === 2) {
      setSecondTooltipOpen(false);
    } else if (toolTipNo === 3) {
      setThirdTooltipOpen(false);
      setMilestoneWidth("1132px");
      setAnchorEl(event.currentTarget);
      setOpenToolTipForCommunication(true);
    } else if (toolTipNo === 4) {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      setOpenEmail(false);
      setOpenComposeEmail(false);
      setBeforeEmail(false);
      setOpenSelectAction(true);
      setShowFinalOrderTimeline(true);
    } else if (toolTipNo === 6) {
      setOpenTrackingDetails(false);
      setShowFinalOrderTimeline(true);
      setShowVesselInfoWithImg(true);
    }

    makeApiCall();
  };

  const initialOrderTimeLine = () => {
    return (
      <Grid container>
        <Grid item xs={12}>
          <Card
            elevation={1}
            style={{
              padding: "32px"
            }}
          >
            <Grid container>
              <Grid item xs={4}>
                <Typography className={classes.milestoneTitleStyle}>
                  Milestones
                </Typography>
                <Grid container>
                  {mockMilestones.map((milestone, i) =>
                    i === 5 && beforeEmail ? (
                      <>
                        <MockTooltipComponent
                          placement="right-end"
                          open={thirdTooltipOpen}
                          popper={classes.checkMilestoneRiskTooltip}
                          tooltipArrowStyle={classes.checkMilestoneRiskArrow}
                          id="checkMileStone"
                          title={
                            <>
                              <Typography className={classes.tooltipTitleStyle}>
                                Click Quality Assurance Milestone
                              </Typography>
                              <p className={classes.tooltipTextStyle}>
                                The order reached the Quality Assurance
                                milestone on July 2, {year}.
                              </p>
                              <p className={classes.tooltipTextStyle}>
                                View updates & comments from suppliers by
                                clicking on this milestone.
                              </p>
                              <Typography className={classes.stepTextStyle} style={{ marginTop: "-10px" }}>
                                (7/19)
                              </Typography>
                            </>
                          }
                          child={
                            <Grid
                              item
                              xs={12}
                              style={{
                                marginLeft: "32px",
                                marginTop: "32px",
                                height: "32px",
                                cursor: "pointer",
                              }}
                              onClick={(event) => {
                                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                                clickOnToolTip("Clicked on Milestone", 3, event)
                              }
                              }
                            >
                              <Badge
                                color="secondary"
                                variant="dot"
                                overlap="circular"
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                                classes={{
                                  anchorOriginTopLeftCircular:
                                    classes.timeLineBadgeStyle,
                                  colorSecondary: classes[milestone.color],
                                }}
                              >
                                <Grid container>
                                  <Grid item xs={12}>
                                    <Grid container>
                                      <Grid item xs={10}>
                                        <Typography
                                          className={
                                            classes.timeLineMilestoneStyle
                                          }
                                        >
                                          {milestone.status}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={10}>
                                        <Typography
                                          className={
                                            classes.timeLineMilestoneStyle
                                          }
                                        >
                                          {milestone.date}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Badge>
                              <div ref={milestonesRef} />
                            </Grid>
                          }
                        />
                      </>
                    ) : (
                      <>
                        {i < 7 && (
                          <Grid
                            item
                            xs={12}
                            style={{
                              marginLeft: "32px",
                              marginTop: "32px",
                              height: "32px",
                              cursor: "pointer",
                            }}
                            onClick={(event) => {
                              if (userContext.userJourneyInfo.payload.steps === 10) {
                                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                                clickOnToolTip("Clicked on Milestone", 3, event)
                              }
                            }
                            }
                          >
                            <Badge
                              color="secondary"
                              variant="dot"
                              overlap="circular"
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                              classes={{
                                anchorOriginTopLeftCircular:
                                  classes.timeLineBadgeStyle,
                                colorSecondary: classes[milestone.color],
                              }}
                            >
                              <Grid container>
                                <Grid item xs={12}>
                                  <Grid container>
                                    <Grid item xs={10}>
                                      <Typography
                                        className={
                                          classes.timeLineMilestoneStyle
                                        }
                                      >
                                        {milestone.status}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                      <Typography
                                        className={
                                          classes.timeLineMilestoneStyle
                                        }
                                      >
                                        {milestone.date}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Badge>
                          </Grid>
                        )}
                        {i >= 8 && !beforeEmail && (
                          <Grid
                            item
                            xs={12}
                            style={{
                              marginLeft: "32px",
                              marginTop: "32px",
                              height: "32px",
                              cursor: "pointer",
                              opacity: 0.5,
                            }}
                            onClick={(event) => {
                              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                              clickOnToolTip("Clicked on Milestone", 3, event)
                            }
                            }
                          >
                            <Badge
                              color="secondary"
                              variant="dot"
                              overlap="circular"
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                              classes={{
                                anchorOriginTopLeftCircular:
                                  classes.timeLineBadgeStyle,
                                colorSecondary: classes[milestone.color],
                              }}
                            >
                              <Grid container>
                                <Grid item xs={12}>
                                  <Grid container>
                                    <Grid item xs={10}>
                                      <Typography
                                        className={
                                          classes.timeLineMilestoneStyle
                                        }
                                      >
                                        {milestone.status}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={10}>
                                      <Typography
                                        className={
                                          classes.timeLineMilestoneStyle
                                        }
                                      >
                                        {milestone.date}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Badge>
                          </Grid>
                        )}
                      </>
                    )
                  )}
                </Grid>
              </Grid>
              <Grid item xs={7}>
                {(thirdTooltipOpen || !showFinalOrderTimeline) &&
                  displayMilestoneShippingInfo()}
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    );
  };

  const displayRealTimeDataWithMap = () => {
    return (
      <>
        <Grid container>
          <Grid item xs={12} style={{ marginTop: "32px" }}>
            <Typography style={{ fontWeight: 600, fontSize: "20px" }}>
              Real Time Delivery Data
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "16px" }}>
            <img
              src={showVesselInfoWithImg ? mapWithMarker : map}
              style={{
                width: "100%",
                height: `${showVesselInfoWithImg ? "336px" : "310px"}`,
              }}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  const displayMilestoneShippingInfo = () => {
    return (
      <>
        {progress === 50 || progress === 45 ? <>
          <Typography className={classes.milestoneTitleStyle} style={{ marginLeft: "15px" }}>
            {progress === 45 ? "PO Placed" : "Quality Assurance"}
          </Typography>

          <><div style={{ display: "flex", flexDirection: "column" }}>
          </div>

            <TableContainer
            >
              <Table className={classes.table} style={{ borderBottom: "none" }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        fontFamily: "Inter",
                        fontWeight: "700",
                        borderBottom: "none"
                      }}
                    >
                      Latest Delivery Date
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        fontFamily: "Inter",
                        fontWeight: "700",
                        borderBottom: "none"
                      }}
                    >
                      Submitted On
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "14px",
                        fontFamily: "Inter",
                        fontWeight: "700",
                        borderBottom: "none"
                      }}
                    >
                      Comments
                    </TableCell>
                  </TableRow>
                </TableHead>
                {
                  MockTable.map((row, index) => (
                    <TableBody
                      key={index}
                      style={{
                        width: "100%",
                        fontFamily: "Inter",
                      }}
                    >
                      <TableRow key={index}>
                        <TableCell
                          style={{ fontSize: "12px", fontFamily: "Inter", borderBottom: "none" }}
                          component="th"
                          scope="row"
                          width="4%"
                        >
                          {row.updated_delivery_date}
                          <br />{row.update_type}
                        </TableCell>
                        <TableCell
                          style={{ fontSize: "12px", fontFamily: "Inter", borderBottom: "none" }}
                          component="th"
                          scope="row"
                          width="4%"
                        >
                          {row.submitted_on}
                        </TableCell>
                        <TableCell
                          width="4%"
                          style={{ fontSize: "12px", fontFamily: "Inter", borderBottom: "none" }}
                        >
                          {row.comment_by}<br />
                          {row.comment}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ))
                }
              </Table>
            </TableContainer>
          </>
        </>
          :
          <Grid container>
            <Grid item xs={12}>
              <Typography className={classes.milestoneTitleStyle}>
                {!beforeEmail ? "In Transit -> Shipped" : "Shipped"}
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: "8px" }}>
              <Typography className={classes.shippingInfoSubTitleStyle}>
                Latest Updated Date: Oct 7, {year}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.shippingInfoSubTitleStyle}>
                Total Delay: 2 days
              </Typography>
            </Grid>
            {!beforeEmail && displayRealTimeDataWithMap()}
            <Grid
              item
              xs={12}
              style={{ marginTop: "32px", marginBottom: "16px" }}
            >
              <Typography className={classes.shippingInfoVesselStyle}>
                Vessel Information
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                maxWidth: "428px",
                height: `${showVesselInfoWithImg ? "auto" : "198px"}`,
                padding: `${showVesselInfoWithImg ? "0px" : "16px"}`,
                border: `${showVesselInfoWithImg ? "1px solid white" : "1px solid black"
                  }`,
                borderStyle: "dotted",
              }}
            >
              {!showVesselInfoWithImg ? (
                <>
                  <Grid container direction="row">
                    <Grid item xs={10}>
                      <Typography className={classes.shippingInfoSubTitleStyle}>
                        We have not received shipping information
                      </Typography>
                    </Grid>
                    <MockTooltipComponent
                      placement="top-start"
                      open={openSelectAction}
                      popper={classes.selectActionRiskTooltip}
                      tooltipArrowStyle={classes.locationArrowStyle}
                      id='selectAction'
                      title={
                        <>
                          <Typography className={classes.tooltipTitleStyle}>
                            Select action
                          </Typography>
                          <p className={classes.tooltipTextStyle}>
                            Click <b>Select Action</b> to either enter your
                            shipping information manually, or request it from the
                            supplier.
                          </p>
                          <Typography className={classes.stepTextStyle}>
                            (13/19)
                          </Typography>
                        </>
                      }
                      child={<></>}
                    />
                  </Grid>

                  <Grid container>
                    <Grid item xs={9}>
                      <Typography className={classes.shippingInfoSubTitleStyle}>
                        from your supplier yet
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                  >
                    <Grid item xs={9}>
                      <Typography className={classes.timeLineMilestoneShipStyle}>
                        Date of last request: Just Now
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      {openSelectActionForm && (
                        <Paper
                          elevation={1}
                          style={{
                            height: "68px",
                            width: "152px",
                            marginTop: "102px",
                            marginLeft: "-294px",
                            right: '81px'
                          }}
                        >
                          <MenuItem
                            className={classes.menuItemStyle}
                            onClick={() => {
                              if (userContext.userJourneyInfo.payload.steps === 16) {
                                setOpenTrackingDetails(true);
                                setOpenSelectActionForm(false);
                                window.scrollTo(0, 1000);
                                makeApiCall();
                              }
                            }}
                          >
                            Enter tracking details
                          </MenuItem>
                          <MenuItem
                            className={classes.menuItemStyle}
                            onClick={() => {
                              setOpenTrackingDetails(true);
                              makeApiCall();
                              window.scrollTo(0, 1000);
                            }}
                          >
                            Request from supplier
                          </MenuItem>
                        </Paper>
                      )}
                    </Grid>
                    <Grid
                      style={{ position: "absolute", marginTop: "63px" }}
                      container
                      item
                      xs={2}
                      direction="row"
                      alignItems="center"
                    >
                      <div
                        className={classes.selectActionButton}
                        onClick={() => {
                          if (userContext.userJourneyInfo.payload.steps === 15) {
                            setOpenSelectActionForm(true);
                            setOpenSelectAction(false);
                            makeApiCall();
                          }
                        }}
                      >
                        <span className={classes.selectText}>Select Action</span>
                        <img src={downloadArrow} />
                      </div>
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={{ marginTop: "-16px", marginLeft: "-24px" }}
                    >
                      <img
                        src={vesselInfo}
                        style={{ width: "100%", height: "112x" }}
                      />
                    </Grid>
                    <Grid item container spacing={2}>
                      {mockVesselInfo.map((vesselInfo) => (
                        <Grid item xs={3} style={{ display: "block" }}>
                          <p
                            style={{
                              fontWeight: 500,
                              fontSize: "12px",
                              lineHeight: "16px",
                              marginTop: "0px",
                            }}
                          >
                            {vesselInfo.title}
                          </p>
                          <p
                            style={{
                              fontWeight: 300,
                              fontSize: "12px",
                              lineHeight: "16px",
                              marginTop: "0px",
                            }}
                          >
                            {vesselInfo.value}
                          </p>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={5}>
                  <Grid container>
                    <Grid item xs={10}>
                      <Typography className={classes.shippingInfoPortStyle}>
                        Source Port
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography className={classes.timeLineMilestoneStyle}>
                        Overall Dwell Time
                      </Typography>
                      <Typography className={classes.timeLineMilestoneStyle}>
                        5 days 9 hours
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={5}>
                  <Grid container>
                    <Grid item xs={10}>
                      <Typography className={classes.shippingInfoPortStyle}>
                        Destination Port
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography className={classes.timeLineMilestoneStyle}>
                        Overall Dwell Time
                      </Typography>
                      <Typography className={classes.timeLineMilestoneStyle}>
                        5 days 9 hours
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      </>
    );
  };

  const orderTimeline = () => {
    return (
      <>
        {openTrackingDetails && (
          <>
            <MockTrackingDetailsForm
              onCallBack={() => {
                clickOnToolTip("Submit Tracking Details", 6);
              }}
            />
          </>
        )}
        {showFinalOrderTimeline && initialOrderTimeLine()}
        {beforeEmail ? (
          <>
            <>{initialOrderTimeLine()}</>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  const communicationHub = () => {
    return (
      <div className={classes.main}>
        <div className={classes.sidebarBox}>
          <MockMilestoneSidebar
            beforeEmail={beforeEmail}
          />
        </div>
        <div className={classes.mainBox}>
          <MockCommunicationHistory
            setOpenEmail={setOpenEmail}
            makeApiCall={makeApiCall}
            openComposeEmail={openComposeEmail}
            openEmail={openEmail}
            beforeEmail={beforeEmail}
          />
        </div>
        {openEmail && (
          <MockEmailDetails
            onCallBack={() => clickOnToolTip("Send Email", 4)}
          />
        )}
      </div>
    );
  };

  const getTabPanel = () => {
    if (defaultCategoryTab === 0 || defaultCategoryTab === "Order Timeline") {
      return <>{orderTimeline()}</>;
    } else if (
      defaultCategoryTab === 1 ||
      defaultCategoryTab === "Communication Hub"
    ) {
      return <>{communicationHub()}</>;
    }
  };

  return (
    <div style={{ overflow: 'auto' }}>
      {progress < 90 && (
        <MockDialogBox
          mockModalData={MockMileStoneTrackerModal}
          image={orderManagerImg}
          stepTitle={MockMileStoneTrackerModal.title}
          callback={() => setFirstTooltipOpen(true)}
        />
      )}
      {progress > 90 && <MockFreeTrial />}
      <MockTooltipComponent
        placement="top-start"
        open={openToolTipForCommunication}
        popper={classes.speakToSupplierPopperTooltip}
        tooltipArrowStyle={classes.speakToSupplierArrow}
        title={
          <>
            <Typography className={classes.tooltipTitleStyle}>
              Speak to your supplier
            </Typography>
            <p className={classes.tooltipTextStyle}>
              You haven’t heard from your supplier in a week.
              <span className={classes.newLine}>
                Let’s follow up on
                your order by clicking <b>Communication Hub</b>.
              </span>
            </p>
            <Typography className={classes.stepTextStyle}>
              (8/19)
            </Typography>
          </>
        }
        child={
          <MockTooltipComponent
            placement="top-start"
            open={secondTooltipOpen}
            title={
              <>
                <Typography className={classes.tooltipTitleStyle}>
                  Order Timeline
                </Typography>
                <p className={classes.tooltipTextStyle}>
                  There’s an issue with your purchase order, but you’ll need
                  more information before you take action.
                </p>
                <p className={classes.tooltipTextStyle}>
                  Go to your <b>Order Timeline</b> to see which milestones have been
                  reached so far.
                </p>
                <Typography className={classes.stepTextStyle} style={{ marginTop: "-10px" }}>
                  (6/19)
                </Typography>
              </>
            }
            popper={classes.timeLinePopperTooltip}
            tooltipArrowStyle={classes.timeLineArrow}
            child={
              <div className={classes.root}>
                <Tabs
                  value={defaultCategoryTab}
                  onChange={handleChange}
                  TabIndicatorProps={{
                    style: {
                      background: "#000000",
                      fontSize: "14px",
                    },
                  }}
                  classes={{
                    indicator: classes.indicatorStyle,
                  }}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {categoryTab.map((t, index) => {
                    return t === defaultCategoryTab ||
                      defaultCategoryTab === index ? (
                      <Tab
                        style={{
                          padding: "10px",
                          textTransform: "none",
                          marginBottom: "22px",
                        }}
                        key={index}
                        label={
                          t === "Order Risks (3)" ? (
                            <div style={{ display: "inline" }}>
                              <span style={{ color: '"#3B82F6"' }}>
                                Order Risks{" "}
                                <span style={{ color: "red" }}>(3)</span>
                              </span>
                            </div>
                          ) : (
                            t
                          )
                        }
                        value={t}
                        className={t}
                        classes={{
                          textColorInherit: classes.textColorInheritStyle,
                        }}
                      />
                    ) : (
                      <Tab
                        style={{
                          padding: "10px",
                          textTransform: "none",
                          marginBottom: "22px",
                        }}
                        key={index}
                        label={t}
                        value={t}
                        className={t}
                        onClick={() => {
                          if (userContext.userJourneyInfo.payload.steps === 9 && index === 0 ||
                            userContext.userJourneyInfo.payload.steps === 11 && index === 1 ||
                            userContext.userJourneyInfo.payload.steps === 14 && index === 0) {
                            setSecondTooltipOpen(false);
                            makeApiCall();
                          }
                        }}
                      />
                    );
                  })}
                </Tabs>
                {defaultCategoryTab === "Order Risks (3)" ||
                  defaultCategoryTab === 3 ? (
                  <MockTooltipComponent
                    title={
                      <>
                        <Typography className={classes.tooltipTitleStyle}>
                          View Risks
                        </Typography>
                        <p className={classes.tooltipTextStyle}>
                          Click <b>Read more</b> to view the this risk to your
                          order which could delay the delivery date.
                        </p>
                        <Typography className={classes.stepTextStyle}>
                          (5/19)
                        </Typography>
                      </>
                    }
                    placement="top"
                    open={firstTooltipOpen}
                    popper={classes.viewOrderRiskTooltip}
                    tooltipArrowStyle={classes.viewRisksTooltipArrowStyle}
                    child={
                      <>
                        {mockOrderTimeLine.map((card, i) => (
                          <Card
                            elevation={1}
                            className={
                              i <= 2
                                ? classes.cardContainerStyle
                                : classes.fadeContainerStyle
                            }
                          >
                            <Grid container>
                              <Grid item xs={1}>
                                {i <= 2 ? (
                                  <Badge
                                    color="secondary"
                                    variant="dot"
                                    overlap="circular"
                                  >
                                    {i <= 2 ? (
                                      <Icon
                                        baseClassName="fas"
                                        className="fa solid fa-truck"
                                        style={{
                                          width: "50px",
                                          height: "44px",
                                          backgroundColor: "#000000",
                                          color: "#ffffff",
                                          border: "1px solid black",
                                          borderRadius: "83%",
                                          padding: "10px",
                                        }}
                                      />
                                    ) : (
                                      <Icon
                                        baseClassName="fas"
                                        className="fa-solid fa-hourglass-end"
                                        style={{
                                          width: "42px",
                                          height: "44px",
                                          backgroundColor: "#000000",
                                          color: "#ffffff",
                                          border: "1px solid black",
                                          borderRadius: "83%",
                                          padding: "11px",
                                          opacity: 0.5,
                                        }}
                                      />
                                    )}
                                  </Badge>
                                ) : (
                                  <Icon
                                    baseClassName="fas"
                                    className="fa-solid fa-hourglass-end"
                                    style={{
                                      width: "42px",
                                      height: "44px",
                                      backgroundColor: "#000000",
                                      color: "#ffffff",
                                      border: "1px solid black",
                                      borderRadius: "83%",
                                      padding: "11px",
                                      opacity: 0.5,
                                    }}
                                  />
                                )}
                              </Grid>
                              <Grid
                                item
                                xs={3}
                                className={i > 2 && classes.fadeStyle}
                              >
                                <Typography
                                  className={classes.timeLineTitleStyle}
                                >
                                  {card.title}
                                </Typography>
                                <Typography
                                  className={classes.timeLineWhenStyle}
                                >
                                  {card.when}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                xs={4}
                                className={i > 2 && classes.fadeStyle}
                              >
                                <p className={classes.timeLineDescriptionStyle}>
                                  {`${card.description} `} <b>{card.date}</b>
                                </p>
                                <p
                                  className={classes.timeLineReadMoreStyle}
                                  onClick={() => {
                                    if (userContext.userJourneyInfo.payload.steps === 8) {
                                      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                                      clickOnToolTip("Order Risk", 1);
                                      setReadMore({
                                        ...readMore,
                                        [i]: !readMore[i],
                                      });
                                    }
                                  }}
                                >
                                  {readMore[i] ? <u>Hide</u> : <u>Read more</u>}
                                </p>
                                {readMore[i] && (
                                  <p className={classes.timeLineReadMoreStyle}>
                                    Chinese military conducts new drills across Taiwan Strait sending 19 warships for patrol in response to comments by US senators who are planning another trip in early October
                                  </p>
                                )}
                              </Grid>
                              <Grid item xs={2}></Grid>
                              <Grid item xs={1}>
                                <div className={classes.selectButton}>
                                  <span className={classes.selectText}>
                                    Respond
                                  </span>
                                  <img src={downloadArrow} />
                                </div>
                              </Grid>
                            </Grid>
                          </Card>
                        ))}
                      </>
                    }
                  />
                ) : (
                  getTabPanel()
                )}
              </div>
            }
          />
        }
      />
      <div ref={bottomRef} />
    </div>
  );
};

export default MockMilestoneTracker;

const useStyles = makeStyles((theme) => ({
  root: {
    flexDirection: "row",
    marginTop: "32px",
  },
  main: {
    gap: "32px",
    display: "flex",
    gap: "20px",
    height: "calc(100vh - 62px)",
    zIndex: "1"
  },
  sidebarBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "30px",
    gap: "32px",
    width: "288px",
    background: "#FFFFFF",
    border: "1px solid #DDDDDD",
  },
  mainBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "30px",
    background: "#F7F8FC",
    width: "100%",
    overflow: "auto",
    height: "90vh",
  },
  cardContainerStyle: {
    height: "auto",
    backgroundColor: "#FFFFFF",
    display: "block",
    padding: "30px",
    paddingBottom: "10px",
    marginBottom: "1px",
  },
  timeLineTitleStyle: {
    fontFamily: "Inter",
    fontWeight: "700",
    fontSize: "14px",
  },
  timeLineWhenStyle: {
    fontFamily: "Inter",
    fontWeight: "400",
    fontSize: "12px",
    marginTop: "8px",
  },
  timeLineDescriptionStyle: {
    fontFamily: "Inter",
    fontWeight: "400",
    fontSize: "12px",
    margin: "0px",
  },
  timeLineReadMoreStyle: {
    fontFamily: "Inter",
    fontWeight: "400",
    fontSize: "12px",
    marginTop: "16px",
    cursor: "pointer",
  },
  selectButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    padding: "10px",
    gap: "10px",
    width: "125px",
    height: "37px",
    background: "#000000",
    marginLeft: "24px",
    cursor: "pointer",
  },
  selectActionButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    padding: "10px",
    width: "153px",
    height: "37px",
    background: "#000000",
    cursor: "pointer",
  },
  selectText: {
    width: "79px",
    height: "17px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "140%",
    display: "flex",
    alignItems: "center",
    color: "#FFFFFF",
    textTransform: "none",
  },
  fadeContainerStyle: {
    height: "112px",
    backgroundColor: "rgba(255, 255, 255, 0.4)",
    display: "block",
    padding: "30px",
    marginBottom: "1px",
  },
  fadeStyle: {
    opacity: 0.5,
  },
  indicatorStyle: {
    display: "none",
  },
  textColorInheritStyle: {
    color: "#3B82F6",
    backgroundColor: "#DBEAFE",
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
    fontWeight: 400,
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: 600,
    marginBottom: "8px",
  },
  milestoneTitleStyle: {
    fontFamily: "Inter",
    fontWeight: "700",
    fontSize: "24px",
  },
  timeLineBadgeStyle: {
    top: "22%",
    left: "-10%",
  },
  timeLineMilestoneStyle: {
    fontFamily: "Inter",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "16px",
    width: "200px",
  },
  timeLineMilestoneBlueColor: {
    color: "#ffffff",
    backgroundColor: "#2673DD",
  },
  timeLineMilestoneFadeColor: {
    color: "#ffffff",
    backgroundColor: "#BFBFBF",
  },
  timeLineMilestoneRedColor: {
    color: "#ffffff",
    backgroundColor: "#FF0000",
  },
  timeLineMilestoneYellowColor: {
    color: "#ffffff",
    backgroundColor: "#FFB800",
  },
  shippingInfoSubTitleStyle: {
    fontFamily: "Inter",
    fontWeight: "400",
    fontSize: "16px",
    margin: "0px",
  },
  shippingInfoVesselStyle: {
    fontFamily: "Inter",
    fontWeight: "600",
    fontSize: "16px",
    margin: "0px",
  },
  timeLineMilestoneShipStyle: {
    fontFamily: "Inter",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "16px",
    width: "300px",
    margin: "32px 0px",
  },
  shippingInfoPortStyle: {
    fontFamily: "Inter",
    fontWeight: "600",
    fontSize: "16px",
    margin: "32px 0px",
  },
  menuItemStyle: {
    whiteSpace: "normal",
    lineHeight: "16.5px",
    fontSize: "12px",
    fontWeight: "400",
    margin: "0px",
  },
  boxStyle: {
    border: "1px solid black",
    margin: "16px 0px",
    backgroundColor: "#FFFFFF",
    marginRight: "8px",
    width: "216px",
  },
  emailButton: {
    display: "flex",
    fleDirection: "row",
    alignItems: "center",
    padding: "8px",
    gap: "8px",
    width: "67px",
    height: "33px",
    background: "#000000",
    borderRadius: "8px",
    marginRight: "16px",
    "&.MuiButtonBase-root:hover": {
      backgroundColor: "#000000",
    },
  },
  viewOrderRiskTooltip: {
    width: "296px",
    height: "104px",
    marginLeft: "-300px",
    marginBottom: "24px",
    zIndex: "999"
  },
  viewRisksTooltipArrowStyle: {
    marginLeft: "142px !important",
  },
  timeLinePopperTooltip: {
    width: "320px",
    height: "176px",
    marginBottom: "30px",
    zIndex: "999"
  },
  timeLineArrow: {
    left: "50px !important",
  },
  speakToSupplierPopperTooltip: {
    width: "300px",
    height: "115px",
    marginLeft: "132px",
    marginBottom: "60px",
    zIndex: "999"
  },
  speakToSupplierArrow: {
    left: "50px !important",
  },
  checkMilestoneRiskTooltip: {
    width: "330px",
    height: "168px",
    marginBottom: "-30px",
    marginLeft: "-100px"
  },
  checkMilestoneRiskArrow: {
    marginLeft: "32px",
    // marginBottom: "-40px !important",
  },
  selectActionRiskTooltip: {
    width: "264px",
    height: "120px",
    marginBottom: "-59px",
    marginLeft: "-400px !important",
  },
  selectActionRiskArrow: {
    marginRight: "32px",
  },
  trackingDetailsRiskTooltip: {
    width: "289px",
    height: "104px",
    marginRight: "30%",
    marginBottom: "16px",
    marginLeft: "20%",
  },
  trackingDetailsRiskArrow: {
    marginRight: "32px",
    marginTop: "32px",
  },
  selectActionButtonRemoveShadowStyle: {
    marginLeft: "-50px",
  },
  composeEmailPopperTooltip: {
    zIndex: "1",
  },
  getTrackingIDPopperTooltip: {
    zIndex: "1",
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  newLine: {
    display: "block",
    marginTop: "15px"
  }
}));
